import React, { useReducer, useEffect } from 'react'
import { Upload, Button } from 'antd'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile, RcFile } from 'antd/lib/upload/interface'
import { GetLocalStorage } from '../../tools/util'

const ACTION_TYPE = {
  PUSH_DATA: 'push_data', // 添加
  CHANGE_DATA: 'change_data', // changefile
}
interface State {
  filedata: any[]
  fileList: UploadFile[]
}
const defaultState: State = {
  filedata: [],
  fileList: [],
}

const reducer = (
  state = defaultState,
  action: { type: string; value: any },
) => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.PUSH_DATA:
      arr.filedata.push(action.value)
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr.fileList = action.value
      return arr
    default:
      return arr
  }
}

const changedataAction = (params: UploadFile[]) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})
interface Props {
  Url?: string // 上传路径
  accept?: string // 控制选择上传文件的类型
  textBtn?: string // 上传文案
  visibleFile?: boolean // 显示隐藏文件上传进度展示
  uploadBtn?: React.ReactNode // 触发上传的元素节点
  beforeUpload?: (file: RcFile, FileList: RcFile[]) => boolean | Promise<any> // 上传之前 处理文件
  onChange?: (data: any, event: any) => void // 变化的文件列表
  style?: React.CSSProperties // style
  className?: string // class 样式
  multiple?: boolean // 多选文件上传
  disabledUpload?: boolean
  openFileDialogOnClick?: boolean // 点击打开文件对话框
  NoUploadButton?: boolean // 是否展示上传按钮
}
// 自定义上传组件
const Customupload = (props: Props) => {
  const [state, dispath] = useReducer(reducer, defaultState)
  const {
    accept,
    textBtn,
    visibleFile,
    onChange,
    Url,
    beforeUpload,
    uploadBtn,
    style,
    className,
    multiple,
    disabledUpload,
    openFileDialogOnClick,
    NoUploadButton,
  } = props

  // 监听filelist变化返回数据集合
  useEffect(() => {
    if (onChange) {
      // onChange(state.filedata);
    }
    // eslint-disable-next-line
  }, [state.filedata])

  function onchangefile(info: UploadChangeParam) {
    let newfileList = [...info.fileList]
    // 仅显示1个最近上传的文件，旧文件将被新文件替换
    newfileList = newfileList.slice(-1)
    // 从响应中读取并显示文件链接
    newfileList = newfileList.map((file) => {
      if (file.response) {
        // 组件将显示file.url作为链接
        file.url = file.response.url
      }
      return file
    })
    // 作为上传过渡项
    const action = changedataAction(newfileList)
    dispath(action)
    if (newfileList.length === 1) {
      const file = newfileList[0]
      // 返回数据
      if (onChange) {
        onChange(file, info.event)
      }
      if (file.status === 'success' || file.status === 'done') {
        // const action = pushdataAction(file);
        // dispath(action);
      }
    }
  }
  return (
    <Upload
      type="select" // 选择模式
      accept={accept}
      action={Url}
      listType="text"
      headers={{
        Authorization: GetLocalStorage('SRM_TOKEN'),
      }}
      multiple={multiple} // 是否多文件上传
      disabled={disabledUpload}
      fileList={state.fileList}
      onChange={onchangefile}
      beforeUpload={beforeUpload}
      showUploadList={
        visibleFile
          ? {
              showDownloadIcon: false,
              showPreviewIcon: false,
              showRemoveIcon: true,
            }
          : false
      }
      openFileDialogOnClick={openFileDialogOnClick}
    >
      {!NoUploadButton &&
        (uploadBtn ? (
          uploadBtn
        ) : (
          <Button type="primary" className={className} style={style}>
            {textBtn ? textBtn : '上传文件'}
          </Button>
        ))}
    </Upload>
  )
}

export default Customupload
import React, { useReducer, useEffect } from 'react'
import { Upload, Button } from 'antd'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile, RcFile } from 'antd/lib/upload/interface'
import { GetLocalStorage } from '../../tools/util'

const ACTION_TYPE = {
  PUSH_DATA: 'push_data', // 添加
  CHANGE_DATA: 'change_data', // changefile
}
interface State {
  filedata: any[]
  fileList: UploadFile[]
}
const defaultState: State = {
  filedata: [],
  fileList: [],
}

const reducer = (
  state = defaultState,
  action: { type: string; value: any },
) => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.PUSH_DATA:
      arr.filedata.push(action.value)
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr.fileList = action.value
      return arr
    default:
      return arr
  }
}

const changedataAction = (params: UploadFile[]) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})
interface Props {
  Url?: string // 上传路径
  accept?: string // 控制选择上传文件的类型
  textBtn?: string // 上传文案
  visibleFile?: boolean // 显示隐藏文件上传进度展示
  uploadBtn?: React.ReactNode // 触发上传的元素节点
  beforeUpload?: (file: RcFile, FileList: RcFile[]) => boolean | Promise<any> // 上传之前 处理文件
  onChange?: (data: any, event: any) => void // 变化的文件列表
  style?: React.CSSProperties // style
  className?: string // class 样式
  multiple?: boolean // 多选文件上传
  disabledUpload?: boolean
  openFileDialogOnClick?: boolean // 点击打开文件对话框
  NoUploadButton?: boolean // 是否展示上传按钮
}
// 自定义上传组件
const Customupload = (props: Props) => {
  const [state, dispath] = useReducer(reducer, defaultState)
  const {
    accept,
    textBtn,
    visibleFile,
    onChange,
    Url,
    beforeUpload,
    uploadBtn,
    style,
    className,
    multiple,
    disabledUpload,
    openFileDialogOnClick,
    NoUploadButton,
  } = props

  // 监听filelist变化返回数据集合
  useEffect(() => {
    if (onChange) {
      // onChange(state.filedata);
    }
    // eslint-disable-next-line
  }, [state.filedata])

  function onchangefile(info: UploadChangeParam) {
    let newfileList = [...info.fileList]
    // 仅显示1个最近上传的文件，旧文件将被新文件替换
    newfileList = newfileList.slice(-1)
    // 从响应中读取并显示文件链接
    newfileList = newfileList.map((file) => {
      if (file.response) {
        // 组件将显示file.url作为链接
        file.url = file.response.url
      }
      return file
    })
    // 作为上传过渡项
    const action = changedataAction(newfileList)
    dispath(action)
    if (newfileList.length === 1) {
      const file = newfileList[0]
      // 返回数据
      if (onChange) {
        onChange(file, info.event)
      }
      if (file.status === 'success' || file.status === 'done') {
        // const action = pushdataAction(file);
        // dispath(action);
      }
    }
  }
  return (
    <Upload
      type="select" // 选择模式
      accept={accept}
      action={Url}
      listType="text"
      headers={{
        Authorization: GetLocalStorage('SRM_TOKEN'),
      }}
      multiple={multiple} // 是否多文件上传
      disabled={disabledUpload}
      fileList={state.fileList}
      onChange={onchangefile}
      beforeUpload={beforeUpload}
      showUploadList={
        visibleFile
          ? {
              showDownloadIcon: false,
              showPreviewIcon: false,
              showRemoveIcon: true,
            }
          : false
      }
      openFileDialogOnClick={openFileDialogOnClick}
    >
      {!NoUploadButton &&
        (uploadBtn ? (
          uploadBtn
        ) : (
          <Button type="primary" className={className} style={style}>
            {textBtn ? textBtn : '上传文件'}
          </Button>
        ))}
    </Upload>
  )
}

export default Customupload
